/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Option1_TextInputs */

const tr_landing_genius_option1_text = /** @type {(inputs: Landing_Genius_Option1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisteme entegre, paketler halinde satın alın. Tüketim anlık görünür; dilediğiniz zaman artırın.`)
};

const en_landing_genius_option1_text = /** @type {(inputs: Landing_Genius_Option1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built into the system, sold in packs. Usage is visible in real time; top up whenever you like.`)
};

const de_landing_genius_option1_text = /** @type {(inputs: Landing_Genius_Option1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ins System integriert, erhältlich in Paketen. Der Verbrauch ist jederzeit sichtbar; stocken Sie auf, wann immer Sie möchten.`)
};

const ru_landing_genius_option1_text = /** @type {(inputs: Landing_Genius_Option1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроены в систему, покупаются пакетами. Расход виден в реальном времени; пополняйте в любой момент.`)
};

/**
* | output |
* | --- |
* | "Built into the system, sold in packs. Usage is visible in real time; top up whenever you like." |
*
* @param {Landing_Genius_Option1_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_option1_text = /** @type {((inputs?: Landing_Genius_Option1_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Option1_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_option1_text(inputs)
	if (locale === "de") return de_landing_genius_option1_text(inputs)
	if (locale === "ru") return ru_landing_genius_option1_text(inputs)
	return tr_landing_genius_option1_text(inputs)
});